import React from 'react';

export function StepNavigation({ sections, currentSection, onStepClick }: {
  sections: string[],
  currentSection: number,
  onStepClick: (index: number) => void
}) {
  return (
    <div className="hidden md:flex fixed right-6 top-1/2 -translate-y-1/2 flex-col gap-6 z-50">
      {sections.map((_, i) => (
        <button
          key={i}
          onClick={() => onStepClick(i)}
          className={`w-2 h-2 rounded-full transition-all ${
            currentSection === i ? 'bg-gray-900 scale-150 dark:bg-gray-100' : 'bg-gray-400 dark:bg-gray-600'
          }`}
        />
      ))}
    </div>
  );
}
